module.exports = __webpack_public_path__ + "img/gal-1.18e3c93c.jpg";